export var PartPublishingStatus;
(function (PartPublishingStatus) {
    PartPublishingStatus["idle"] = "idle";
    PartPublishingStatus["in_progress"] = "in_progress";
    PartPublishingStatus["success"] = "success";
    PartPublishingStatus["failure"] = "failure";
})(PartPublishingStatus || (PartPublishingStatus = {}));
export var PartUpdatingStatus;
(function (PartUpdatingStatus) {
    PartUpdatingStatus["idle"] = "idle";
    PartUpdatingStatus["in_progress"] = "in_progress";
    PartUpdatingStatus["success"] = "success";
    PartUpdatingStatus["failure"] = "failure";
    PartUpdatingStatus["denied"] = "denied";
})(PartUpdatingStatus || (PartUpdatingStatus = {}));
export const partPropertyKeys = { partType: "Type", category: "category" };
/*
   These placeholders are used by file importers to substitute for specific text values,
   which are later replaced by display functions
*/
export var KicadImportTextPlaceholder;
(function (KicadImportTextPlaceholder) {
    KicadImportTextPlaceholder["valueReplace"] = "*`VALUE`*";
    KicadImportTextPlaceholder["refReplace"] = "*`REF`*";
    KicadImportTextPlaceholder["ultralibrarianTag"] = "ultralibrarian";
})(KicadImportTextPlaceholder || (KicadImportTextPlaceholder = {}));
export var TextPlaceholder;
(function (TextPlaceholder) {
    TextPlaceholder["elementDesignator"] = "this.element.designator";
    TextPlaceholder["elementDefaultValue"] = "this.element.defaultPropertyValue ? this.element.defaultPropertyValue : \" \"";
})(TextPlaceholder || (TextPlaceholder = {}));
//# sourceMappingURL=SharedDataModels.js.map